import React, { useCallback, useEffect, useMemo, useState } from "react";
import { AprobarSolicitudesHEDTO, DatosRecalculo, ValoresRecalculo } from "./typesAprobarSolicitudHE";
import { Table } from "react-bootstrap";
import { Pagination, PaginationItem, PaginationLink, Col, Input, Row, Label, Form } from "reactstrap";
import { ReactComponent as IconPdf } from "../../../../assets/icons/HorasExtras/PDF.svg"
import { ReactComponent as IconX } from "../../../../assets/icons/HorasExtras/X.svg"
import { ReactComponent as IconCheck } from "../../../../assets/icons/HorasExtras/Chek.svg"
import { ReactComponent as IconRecalcular } from "../../../../assets/icons/HorasExtras/recalcular.svg"

import { EnvioSolicitudRechazada, FirmarEnviarSolicitudNominaTH, FirmaTodasSolicitudesNominaTH, VistaPreviaSolicitudHETHoUsuario } from "./functionsAprobarSolicitudesHE";
import { showAlert } from "../Parametros Horas Extras/Actividades/ActividadesHorasExtras";
import ModalVistaPreviaDocumentos from "components/Varios/Modals/ModalVistaPreviaDocumentos";
import ModalVistaPreviaDocumento from "components/Varios/Modals/ModalVistaPreviaDocumento";
import ModalRechazo from "components/DirectivoUnidad/AprobacionSolicitudes/ModalRechazoSolicitud";
import ModalCargando from "components/Varios/ModalCargando";
import { GetDocumentVistaPrevia2 } from "helpers/files";
import "../../../../assets/scss/Horas Extras/RevisionSolicitudes.scss"


import { string } from "yargs";
import { promises, truncateSync } from "fs";
import { ObtenerFechaFromIsoFormat } from "functions/DatesFunctions";
import ModalConfirmacion from "components/Varios/Modals/ModalConfirmacion";
import { authenticationService } from "services/authentication.service";
import FotoPerfil from "components/Sidebar/FotoPerfil";
import Cargando from "components/Varios/Cargando";
import { GetFotoBase64ByIdentificacion } from "services/FotoServices";
import { GetDataRecalculoSolicitud, RecalcularSolicitudHE } from "./ServicesRevisarSolicitudesHE";

type PropsAprobarSolicitudes = {
    informacionContenido: AprobarSolicitudesHEDTO[],
    actualizar: () => Promise<void>,
}




export default function TableAprobarSolicitudes(props: PropsAprobarSolicitudes) {
    const { informacionContenido } = props;

    const [rechazo, setrechazo] = useState<boolean>(false);


    const [solicitudRecalcular, setsolicitudRecalcular] = useState<AprobarSolicitudesHEDTO | undefined>(undefined)

    //const [fotoServidor, setfotoServidor] = useState<string | undefined>(undefined)
    const [dataRecalculo, setdataRecalculo] = useState<DatosRecalculo | undefined>(undefined)
    const [cargandodataRecalculo, setcargandodataRecalculo] = useState<boolean>(false)
    const [guardandoRecalculo, setguardandoRecalculo] = useState<boolean>(false)


    const [infoIndividual, setinfoIndividual] = useState<AprobarSolicitudesHEDTO | null>(null);
    const [loadingAccion, setloadingAccion] = useState<boolean>(false);
    const [urlDocSolicitud, seturlDocSolicitud] = useState<string>("");
    const [urlDocAprobar, seturlDocAprobar] = useState<string>("");

    const [sortColumn, setSortColumn] = useState<string | null>('');
    const [sortDirection, setSortDirection] = useState('asc');
    const [sortToggle, setSortToggle] = useState(false);
    const [datosOrdenados, setDatosOrdenados] = useState([...informacionContenido]);

    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {


        return () => {
            setDatosOrdenados(props.informacionContenido)
        }
    }, [props.informacionContenido])


    async function GenerarVistaPreviaAprobatoriaHE(idSolicitud: number) {
        setloadingAccion(true)
        const respuestaVistaPrevia = await VistaPreviaSolicitudHETHoUsuario(idSolicitud, "NOMINA");

        if (respuestaVistaPrevia.status === 200 && respuestaVistaPrevia.dataResponse) {
            seturlDocAprobar(respuestaVistaPrevia.dataResponse)
        }
        else {
            showAlert("No es posible cargar la vista previa del documento", false);
        }
        setloadingAccion(false)
    }

    async function aceptarSolicitud(solicitud: AprobarSolicitudesHEDTO) {
        setinfoIndividual(solicitud);
        await GenerarVistaPreviaAprobatoriaHE(solicitud.idSolicitud);
    }

    async function GenerarVistaPreviaSolicitudHE(refArchivo: string) {
        setloadingAccion(true)
        let urlPresentar = await GetDocumentVistaPrevia2(refArchivo);
        if (urlPresentar) {
            seturlDocSolicitud(urlPresentar);
        }
        else {
            seturlDocSolicitud("");
            showAlert("No es posible cargar la vista previa del documento de marcaciones", false);
        }

        setloadingAccion(false)
    }

    async function enviarFirmaNominaTH(datos: AprobarSolicitudesHEDTO) {
        const fecha = datos.fechaSolicitud.split("/");
        datos.fechaSolicitud = `${fecha[2]}-${fecha[1]}-${fecha[0]}`;

        const listaSolicitudes = Array.isArray(datos) ? datos : [datos];

        const respuestafirma = await FirmaTodasSolicitudesNominaTH(listaSolicitudes);
        if (respuestafirma.status === 200) {
            showAlert("La solicitud ha sido revisada y firmada correctamente", true);
            props.actualizar();
        }
        else {
            const mensajeDefault = "Ha ocurrido un inconveniente al intentar firmar su solicitud de Horas Extras."
            showAlert(respuestafirma.errorMessage ?? mensajeDefault, false);
        }
    }

    async function rechazarSolicitud(idSolicitud, observacion) {
        if (idSolicitud) {
            const solicitudRechazada = await EnvioSolicitudRechazada(idSolicitud, observacion);
            if (solicitudRechazada.status == 200) {
                showAlert("La solicitud ha sido negada correctamente", true);
                props.actualizar();
                return 1;
            }
            else {
                const mensajeDefault = "Ha ocurrido un inconveniente al intentar de negar su solicitud"
                showAlert(solicitudRechazada.errorMessage ?? mensajeDefault, false);
                return -1;
            }
        }
        return 1;
    }

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;

    //ordena de forma alfabetica los nombres de las solicitudes
    useEffect(() => {
        handleSort("nombres");
    }, [])

    const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setRowsPerPage(parseInt(event.target.value));
        setCurrentPage(1);
    };

    //reorganiza ascendente o descendente los nombres
    const handleSort = (column) => {
        const isAsc = sortColumn === column && sortDirection === 'asc';
        setSortColumn(column);
        setSortDirection(isAsc ? 'desc' : 'asc');
        setSortToggle(!sortToggle); // Cambia el estado para forzar re-render
    };

    const applySorting = (data) => {
        if (!sortColumn) return data;

        if (data) {
            const sortedData = [...data].sort((a, b) => {
                if (a && b) {
                    var valA = a[sortColumn];
                    var valB = b[sortColumn];

                    if (typeof valA === "string" && typeof valB === "string") {
                        // Sort strings using localeCompare
                        return valA.localeCompare(valB) * (sortDirection === 'asc' ? 1 : -1);
                    } else if (typeof valA === "number" && typeof valB === "number") {
                        // Sort numbers directly
                        return (valA - valB) * (sortDirection === 'asc' ? 1 : -1);
                    }

                    // Handle potential cases where types are mixed or unexpected
                    return 0;
                }
                return 0;
            });
            return sortedData;
        }
    };


    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reiniciar la paginación cuando se busca
    };
    //filtrado para el buscador
    const filteredSolicitudes = (datosOrdenados && datosOrdenados.length > 0) ? datosOrdenados.filter(solic =>
    (solic.nombres.toLowerCase().includes(searchTerm.toLowerCase()) ||
        solic.regimen.toLowerCase().includes(searchTerm.toLowerCase()) ||
        solic.identificacion.toLowerCase().includes(searchTerm.toLowerCase()))
    ) : [];

    //presenta las filas asignadas
    const sortedSolicitudes = applySorting(filteredSolicitudes);
    let currentRows: AprobarSolicitudesHEDTO[] = sortedSolicitudes.slice(indexOfFirstRow, indexOfLastRow);

    //obtiene el numero de paginas segun la cantidad de datos
    const pageNumbers: number[] = [];
    for (let i = 1; i <= Math.ceil(filteredSolicitudes.length / rowsPerPage); i++) {
        pageNumbers.push(i);
    }

    const renderPageNumbers = pageNumbers.map(number => (
        <PaginationItem key={number} active={number === currentPage}>
            <PaginationLink onClick={() => setCurrentPage(number)}>
                {number}
            </PaginationLink>
        </PaginationItem>
    ));

    const contenidoModalRechazo = useMemo(() => {
        if (infoIndividual) {
            return (
                <React.Fragment>
                    <div className="table-responsive">
                        <Table className="table_planificacion_he table table-bordered">
                            <thead className="cabeceras_tabla_servidores_act_he" style={{ fontSize: "0.7rem" }}>
                                <tr>
                                    <th colSpan={1} align={"left"}> Fecha</th>
                                    <th colSpan={1} align={"center"}> Cédula </th>
                                    <th colSpan={1} align={"center"}> Nombres </th>
                                    <th colSpan={1} align={"center"}> Unidad </th>
                                    <th colSpan={1} align={"center"}> Régimen </th>
                                    <th colSpan={1} align={"center"}> RMU <br /> vigente </th>
                                    <th colSpan={1} align={"center"}> Total Horas <br /> Supl. </th>
                                    <th colSpan={1} align={"center"}> Total Horas <br /> Extra. </th>
                                    <th colSpan={1} align={"center"}> Total Horas <br /> Extras </th>
                                    <th colSpan={1} align={"center"}> Valor Horas <br /> Supl. </th>
                                    <th colSpan={1} align={"center"}> Valor Horas <br /> Extra. </th>
                                    <th colSpan={1} align={"center"}> Valor a Recibir </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className='rows_tabla_planificacion_he' style={{ fontSize: "0.7rem" }}>
                                    <td className="centrado"> {infoIndividual.fechaSolicitud} </td>
                                    <td className="centrado"> {infoIndividual.identificacion} </td>
                                    <td className="izquierda"> {infoIndividual.nombres} </td>
                                    <td className="centrado"> {infoIndividual.unidad} </td>
                                    <td className="centrado"> {infoIndividual.regimen} </td>
                                    <td className="centrado"> {infoIndividual.rmu.toFixed(2)} </td>
                                    <td className="centrado"> {infoIndividual.heSumplementarias} </td>
                                    <td className="centrado"> {infoIndividual.heExtraordinaria} </td>
                                    <td className="centrado"> {infoIndividual.tHorasExtras} </td>
                                    <td className="centrado"> {infoIndividual.vHeSuplementarias?.toFixed(2)} </td>
                                    <td className="centrado"> {infoIndividual.vHeExtraordinaria?.toFixed(2)} </td>
                                    <td className="centrado"> {infoIndividual.tvHorasExtras?.toFixed(2)} </td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                </React.Fragment>
            );
        }

    }, [infoIndividual])

    async function defaultRechazo() {
        setrechazo(false);
    }


    async function GetDataRecalculo(solicitudRecalcular: AprobarSolicitudesHEDTO) {
        setcargandodataRecalculo(true)
        const identificacion: string = solicitudRecalcular.identificacion;
        const idsolicitud: number = solicitudRecalcular.idSolicitud;
        const responseDataRecalculo = await GetDataRecalculoSolicitud(identificacion, idsolicitud)
        if (responseDataRecalculo.status === 200) {
            setdataRecalculo(responseDataRecalculo.dataResponse)
        }
        setcargandodataRecalculo(false)
    }

    async function GuardarRecalculoValoresSolicitud(solicitudRecalcular: AprobarSolicitudesHEDTO | undefined) {
        if (!solicitudRecalcular) {
            showAlert("Indique la solicitud que desea actualizar", false);
            return -1;
        }
        setguardandoRecalculo(true)
        const identificacion: string = solicitudRecalcular.identificacion;
        const idsolicitud: number = solicitudRecalcular.idSolicitud;
        const responseDataRecalculo = await RecalcularSolicitudHE(identificacion, idsolicitud)
        var success: boolean = false
        if (responseDataRecalculo.status === 200) {
            
            success = true
            showAlert("Los valores de la solicitud han sido actualizados con éxito",true)
        }
        else {
            showAlert(responseDataRecalculo.errorMessage ?? "No ha sido posible actualizar los valores de la solicitud", false);

        }
        setguardandoRecalculo(false)
        return success ? 1 : -1
    }

    const ContenidoModalRecalculo = useMemo(() => {
        if (solicitudRecalcular !== undefined && dataRecalculo) {


            return (
                <div>
                    <div className="contenedor-superior">
                        <div className="tabla-superior responsive-table-wrapper">
                            <table className="tabla-info" >
                                <thead>
                                    <tr>
                                        <th className="encabezado-servidor">Datos de servidor</th>
                                        <th colSpan={3} className="encabezado-horas">Horas extras solicitadas</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="">
                                            <div className="contenido-celda">
                                                <div className="content-celda-foto">
                                                    <div className="foto">
                                                        {
                                                            !cargandodataRecalculo &&
                                                            <FotoPerfil
                                                                src={dataRecalculo.foto ?? ""}
                                                                styleimg="avatar"
                                                            />
                                                        }
                                                        {
                                                            cargandodataRecalculo && <Cargando />
                                                        }
                                                    </div>
                                                    <div className="datosPersona">
                                                        <div className="nombre"> {solicitudRecalcular.nombres}</div>
                                                        <div className="cedula">{solicitudRecalcular.identificacion}</div>
                                                    </div>
                                                </div>



                                            </div>



                                        </td>
                                        <td>
                                            <div className="contenido-celda">
                                                <div className="titulo">Total Horas Suplem.</div>
                                                <div className="valor">{dataRecalculo.valoresRecalculo.recalculosupl}</div>
                                            </div>

                                        </td>
                                        <td>
                                            <div className="contenido-celda">
                                                <div className="titulo">Total Horas Extraor.</div>
                                                <div className="valor">{dataRecalculo.valoresRecalculo.recalculoextr}</div>
                                            </div>

                                        </td>
                                        <td>
                                            <div className="contenido-celda">
                                                <div className="titulo">Total Horas Extras</div>
                                                <div className="valor">{dataRecalculo.valoresRecalculo.recalculosupl + dataRecalculo.valoresRecalculo.recalculoextr}</div>
                                            </div>

                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>


                    <div className="contenedor-inferior">
                        <div className="tabla-inferior">
                            <div className="titulo">VALORES ACTUALES</div>
                            <table className="tabla-secundaria" >
                                <thead>
                                    <tr>
                                        <th className="encabezado-inferior1">Valor Horas Suplem.</th>
                                        <th className="encabezado-inferior1">Valor Horas Extraor.</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>$ {solicitudRecalcular.vHeSuplementarias}</td>
                                        <td>$ {solicitudRecalcular.vHeExtraordinaria}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="tabla-inferior">
                            <div className="titulo">VALORES RECALCULADOS</div>
                            <table className="tabla-secundaria" >
                                <thead>
                                    <tr>
                                        <th className="encabezado-inferior2">Valor Horas Suplem.</th>
                                        <th className="encabezado-inferior2"> Valor Total H Extra</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>$ {dataRecalculo.valoresRecalculo.recalculosupl}</td>
                                        <td>$ {dataRecalculo.valoresRecalculo.recalculoextr}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>

            )
        }
        else if(cargandodataRecalculo){
            return (<div>
                <Cargando mensaje="Cargando información..." />
            </div>)
        }
        else {
            return (<></>)

        }



    }, [solicitudRecalcular, dataRecalculo, cargandodataRecalculo])


    useEffect(() => {
        if (solicitudRecalcular) {
            GetDataRecalculo(solicitudRecalcular)
        }
    }, [solicitudRecalcular])



    return (
        <React.Fragment>
            <Row>
                <Col md="3">
                    <div className="d-flex align-items-center justify-content-start">
                        <Label for="rowsPerPageSelect" className="mb-0 mr-2">Mostrar</Label>
                        <select
                            id="rowsPerPageSelect"
                            value={rowsPerPage}
                            onChange={handleRowsPerPageChange}
                            className="custom-select custom-select-sm mr-2"
                            style={{ width: 'auto' }}
                        >
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                        </select>
                        <Label className="mb-0">filas</Label>
                    </div>
                </Col>
                <Col xs="3" md="3" className="d-flex align-items-end justify-content-end ml-auto">
                    <Input
                        type="text"
                        placeholder="Buscar..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                        className="form-control-sm" // Reduce el tamaño del input
                    />
                </Col>
            </Row>
            {currentRows.length < 1 && (
                <Label className={"font-15"}>
                    No se encontraron datos
                </Label>
            )}
            {currentRows && currentRows.length > 0 && (
                <div className="table-responsive">
                    <Table className="table_planificacion_he table-bordered">
                        <thead className="cabeceras_tabla_servidores_act_he">
                            <tr>
                                <th colSpan={1} align={"center"}> # </th>
                                <th colSpan={1} align={"left"} onClick={() => handleSort("fechaSolicitud")}> Fecha <br /> Solic.</th>
                                <th colSpan={1} align={"left"} onClick={() => handleSort("mesDescripcion")}> Mes <br /> Solic.</th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("identificacion")}> Cédula </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("nombres")}> Nombres </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("unidad")}> Unidad </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("regimen")}> Régimen </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("rmu")}> RMU <br /> vigente </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("heSumplementarias")}> Total Horas <br /> Supl. </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("heExtraordinaria")}> Total Horas <br /> Extra. </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("tHorasExtras")}> Total Horas <br /> Extras </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("vHeSuplementarias")}> Valor Horas <br /> Supl. </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("vHeExtraordinaria")}> Valor Horas <br /> Extra. </th>
                                <th colSpan={1} align={"center"} onClick={() => handleSort("tvHorasExtras")}> Valor a Recibir </th>

                                <th colSpan={1} align={"center"}> Acciones </th>

                            </tr>
                        </thead>
                        <tbody className="tbodyAprobacionNominaTH">
                            {currentRows.map((ic, i) => {
                                const globalIndex = indexOfFirstRow + i + 1
                                return (
                                    <React.Fragment key={i}>
                                        <tr className=''>
                                            <td className="centrado"> {globalIndex} </td>
                                            <td className="centrado"> {ic.fechaSolicitud} </td>
                                            <td className="centrado"> {ic.mesDescripcion} </td>
                                            <td className="centrado"> {ic.identificacion} </td>
                                            <td className="izquierda"> {ic.nombres} </td>
                                            <td className="centrado"> {ic.unidad} </td>
                                            <td className="centrado"> {ic.regimen} </td>
                                            <td className="centrado"> {ic.rmu.toFixed(2)} </td>
                                            <td className="centrado"> {ic.heSumplementarias} </td>
                                            <td className="centrado"> {ic.heExtraordinaria} </td>
                                            <td className="centrado"> {ic.tHorasExtras} </td>
                                            <td className="centrado"> {ic.vHeSuplementarias?.toFixed(2)} </td>
                                            <td className="centrado"> {ic.vHeExtraordinaria?.toFixed(2)} </td>
                                            <td className="centrado"> {ic.tvHorasExtras?.toFixed(2)} </td>
                                            <td>
                                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "5px" }}>
                                                    {/*{ic.estado.trim() != "RV" &&*/}
                                                    {/*    <IconCheck*/}
                                                    {/*        className={"icono-blue-2"}*/}
                                                    {/*        data-toggle="tooltip"*/}
                                                    {/*        data-placement="top"*/}
                                                    {/*        title="Aprobar"*/}
                                                    {/*        onClick={() => {*/}
                                                    {/*            aceptarSolicitud(ic);*/}
                                                    {/*        }}*/}
                                                    {/*    />*/}
                                                    {/*}*/}
                                                    <IconX
                                                        className={"icono-blue-2"}
                                                        data-toggle="tooltip"
                                                        data-placement="top"
                                                        title="Rechazar"
                                                        onClick={() => {
                                                            setrechazo(true);
                                                            setinfoIndividual(ic);
                                                        }}
                                                    />
                                                    {ic.refArchivo !== null &&
                                                        <IconPdf
                                                            className={"icono-blue-2"}
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            title="PDF Marcaciones"
                                                            onClick={() => GenerarVistaPreviaSolicitudHE(ic.refArchivo)}
                                                        />
                                                    }
                                                    <IconRecalcular
                                                        className={"iconRecalcularHE"}
                                                        data-toggle="tooltip"
                                                        data-placement="top"
                                                        title="Recalcular Valores"
                                                        onClick={() => setsolicitudRecalcular(ic)}
                                                    />

                                                </div>
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                )
                            })}
                        </tbody>

                    </Table>
                </div>
            )}
            <Pagination size="sm" className="pagination_planificacion_he">
                {renderPageNumbers}
            </Pagination>

            <ModalCargando
                show={loadingAccion != false}
                onClose={() => setloadingAccion(false)}
                textoCargando='Cargando Datos'
                size='md'
            />
            <ModalVistaPreviaDocumentos
                show={urlDocSolicitud !== ""}
                cargandoDatos={loadingAccion}
                size='xl'
                tituloModal='Solicitud de Horas Extras'
                onClose={() => seturlDocSolicitud("")}
                urlArchivo={urlDocSolicitud}
                allHeight={true}
            />
            {infoIndividual !== null &&
                <ModalVistaPreviaDocumento
                    show={urlDocAprobar !== ""}
                    urlArchivo={urlDocAprobar}
                    size="xl"
                    tituloModal=""
                    cargandoDatos={loadingAccion}
                    onClose={() => seturlDocAprobar("")}
                    accionOnAccept={true}
                    asyncAccion={() => enviarFirmaNominaTH(infoIndividual)}
                    closeAfterAsync={true}
                    botonCerrar={true}
                    zoomDefaultValue={1.5}
                />
            }
            <ModalRechazo
                show={rechazo !== false}
                size="xl"
                onClose={() => setrechazo(false)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea negar la solicitud de horas extras?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={(observacion) => rechazarSolicitud(infoIndividual?.idSolicitud, { Observacion: observacion })}
                contentModal={contenidoModalRechazo}
                tituloModal={"Negación Solicitud de Horas Extras"}
                asyncAfterOnClose={() => defaultRechazo()}
                labelObservacion={"Indique el motivo de negación"}
                botonesAccionParteSuperior={true}
                classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
                maxLength={500}

            />

            <ModalConfirmacion
                size="xl"
                show={solicitudRecalcular !== undefined || cargandodataRecalculo}
                asyncAccion={true}
                asyncClose={true}
                asyncOnClick={async () => {
                    var exitoso = await GuardarRecalculoValoresSolicitud(solicitudRecalcular);
                    if(exitoso > 0){
                        await props.actualizar();
                    }   
                    return 1
                }
                }
                closeAfterAccion={true}
                hideBotonCerrar={false}
                contentModal={ContenidoModalRecalculo}
                mensajeConfirmacion=""
                nombreBotonAccion="Aceptar"
                nombreBotonCerrarModal='Cancelar'
                classNameBotonAccion='mr-2 btnEspolPrimary btn btn-primary'
                classNameBotonCerrarModal2='btn-white-red btn btn-secondary'
                onClose={() => {
                    setsolicitudRecalcular(undefined)
                    setdataRecalculo(undefined)
                }}
                tituloModal="RECÁLCULO DE HORAS EXTRAS"
            />
        </React.Fragment>
    )
}

